import { Columns } from './columns';
import { Hero } from './hero';
import { HeroSecondary } from './heroSecondary';
import { Testimonial } from './testimonial';
import { GatedContent } from './gatedContent';
import { ImageText } from './imageText';
import { BioCollection } from './bioCollection';
import { Header } from './header';
import { Brands } from './brands';
import { Footer } from './footer';
import { Action } from './action';
import { ProjectCollection } from './projectCollection';
import { BlogPostCollection } from './blogPostCollection';
import { TestimonialCollection } from './testimonialCollection';
// import { Flyin } from './flyin';
import { Form } from './form';
import { HeroCentered } from './heroCentered';
import { FullWidthQuote } from './fullWidthQuote';
import { FullWidthLinkBlock } from './fullWidthLinkBlock';
import { TechPartnerCollection } from './techPartnerCollection';
import { TechPartner } from './techPartner';
import { FullWidthBlurb } from './fullWidthBlurb';
import { ImageTextCollection } from './imageTextCollection';
import { SectionWithMarquee } from './sectionWithMarquee';
import { Collage } from './collage';
import { ImageTextAlternative } from './imageTextAlternative';
import { CaseStudyFullImage } from './caseStudyFullImage';
import { CaseStudyHero } from './caseStudyHero';
import { CaseStudyStats } from './caseStudyStats';
import { CaseStudyContentAndMobileImages } from './caseStudyContentAndMobileImages';
import { CaseStudyContentAndDesktopImage } from './caseStudyContentAndDesktopImage';
import { CaseStudyContentAndImage } from './caseStudyContentAndImage';
import { CaseStudyQuote } from './caseStudyQuote';
import { CaseStudyCentralContent } from './caseStudyCentralContent';

export const components: { [index: string]: any } = {
  header: Header,
  columns: Columns,
  collage: Collage,
  hero: Hero,
  heroSecondary: HeroSecondary,
  technologyPartner: TechPartner,
  testimonial: Testimonial,
  gatedContent: GatedContent,
  imageText: ImageText,
  imageTextCollection: ImageTextCollection,
  bioCollection: BioCollection,
  projectCollection: ProjectCollection,
  testimonialCollection: TestimonialCollection,
  fullWidthQuote: FullWidthQuote,
  fullWidthLinkBlock: FullWidthLinkBlock,
  fullWidthBlurb: FullWidthBlurb,
  imageTextAlternative: ImageTextAlternative,
  sectionWithMarquee: SectionWithMarquee,
  // flyin: Flyin, // this was doubling up the main /page.txt flyin on some page
  blogPostCollection: BlogPostCollection,
  brands: Brands,
  footer: Footer,
  action: Action,
  form: Form,
  heroCentered: HeroCentered,
  techPartnerCollection: TechPartnerCollection,
  caseStudyFullImage: CaseStudyFullImage,
  caseStudyHero: CaseStudyHero,
  caseStudyStats: CaseStudyStats,
  caseStudyContentAndMobileImages: CaseStudyContentAndMobileImages,
  caseStudyContentAndDesktopImage: CaseStudyContentAndDesktopImage,
  caseStudyContentAndImage: CaseStudyContentAndImage,
  caseStudyQuote: CaseStudyQuote,
  caseStudyCentralContent: CaseStudyCentralContent,
  default: null,
};
